import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

//Formattazione formato italiano
export class NgbDateMomentParserFormatter extends NgbDateParserFormatter {
  constructor(private momentFormat: string) {
    super();
  }

  format(date: NgbDateStruct): string {
    if (date === null) {
      return "";
    }
    let d = moment({ year: date.year, month: date.month - 1, date: date.day });
    return d.isValid() ? d.format(this.momentFormat) : "";
  }

  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    let d = moment(value, this.momentFormat);
    return d.isValid() ? { year: d.year(), month: d.month() + 1, day: d.date() } : null;
  }
}

/*MINI TUTORIAL IMPLEMENTAZIONE
 * Nel TS bisogna importare
 * UNO. @ViewChildren(datepickerComponent) datePicker: QueryList<datepickerComponent>; //Prendiamo cosi tutti gli input date per eseguire il reset
 * DUE. Dove c'è l'errore delle date e quindi bisogna svuotarle this.datePicker.forEach((item: any) => item.clear());
 * TRE. La funzione takeDate() Esempio:  takeDate(event: any, field: string) {
    if (field === "start_date") {
      this.formGroupDetail.patchValue({
        start_date: event,
      });
    }
  }
 * QUATTRO. Se devi immettere il valore che ti arriva dal back end utilizza il formato YYYY-MM-DD
 * CINQUE. Se hai bisogno d'immettere la data dal back-end utilizza [defaultDate]="formGroupOrder.value.from" come input sul HTML
 *
 * Attenzione se il datePickerComponent si trova in una modale il punto numero DUE è inutile in quanto non sarà possibile svuotare le date con la funzione clear
 * Utilizza il query selector come in questo esempio const inputStartDate: any = document.querySelector("#start_date input"); inputStartDate.value = "";
 *
 * Nel html importi il componente con tutte le possibili opzioni d'input ad esempio
 * <app-datepickr
                  id="start_date"
                  (onSelect)="takeDate($event, 'start_date'); calculateDifferenceInMonth(); scrollToDocumentSection()"
                  [minDateToday]="true"
                  [isInvalid]="!formGroupDetail.value.start_date && showErrors"
                ></app-datepickr>
                <div class="invalid-date" *ngIf="!formGroupDetail.value.start_date && showErrors">{{ "ERRORS.INSERT_START_DATE" | translate }}</div>*/

@Component({
  selector: "app-datepickr",
  template: `
    <div class="input-group input-group-merge" [ngClass]="{'is-invalid' : isInvalid}">
      <input class="form-control cursor-pointer" [ngClass]="{'is-invalid' : isInvalid}" [placeholder]="placeholder" name="dp" ngbDatepicker onkeydown="return false" #d="ngbDatepicker"
             [readonly]="isReadOnly" [displayMonths]="1" [navigation]="navigation" [outsideDays]="outsideDays" [minDate]="minDate" [maxDate]="maxDate"
             [showWeekNumbers]="showWeekNumbers" [(ngModel)]="selectedDate" (click)="!isReadOnly ? d.toggle() : null" (ngModelChange)="sendDate()" />
      <div class="input-group-append">
    <span class="input-group-text date-calendar cursor-pointer" [ngClass]="{'readonly' : isReadOnly}" (click)="!isReadOnly ? d.toggle() : null">
      <i class="feather font-small-4" data-feather="calendar"></i>
    </span>
      </div>
    </div>`
})
export class DatepickrComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @Input() placeholder: string = 'gg/mm/aaaa';
  @Input() displayMonths: number = 2;
  @Input() maxDate: any = null; //Min e Max date passare un oggetto es { year: new Date().getFullYear(),month: new Date().getMonth() + 1,day: new Date().getDate()}
  @Input() minDate: any = null;
  @Input() minDateToday: boolean = false;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Input() defaultDate: any = null;
  @Input() isInvalid: boolean = false;
  @Input() isReadOnly: boolean | Promise<undefined> = false;

  public selectedDate: any = null;
  public navigation = "select";
  public outsideDays = "visible";
  public showWeekNumbers = false;

  ngOnInit(): void {
    if (!!this.defaultDate) {
      this.selectedDate = { year: new Date(this.defaultDate).getFullYear(), month: new Date(this.defaultDate).getMonth() + 1, day: new Date(this.defaultDate).getDate() };
    }

    if (this.minDateToday) {
      this.minDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
    }

    if (typeof this.minDate === "string") {
      const [year, month, day] = this.minDate.split("-");
      this.minDate = { year: parseInt(year), month: parseInt(month), day: parseInt(day) };
    }

    if (typeof this.maxDate === "string") {
      const [year, month, day] = this.maxDate.split("-");
      this.maxDate = { year: parseInt(year), month: parseInt(month), day: parseInt(day) };
    }
  }

  //Funzione che gestisce la formattazione della data
  sendDate() {
    if (this.selectedDate.hasOwnProperty("year") && this.selectedDate.hasOwnProperty("month") && this.selectedDate.hasOwnProperty("day")) {
      this.onSelect.emit(`${this.selectedDate.year}-${String(this.selectedDate.month).padStart(2, "0")}-${String(this.selectedDate.day).padStart(2, "0")}`);
    }
  }

  //Funzione che viene chiamata dal componente padre
  clear() {
    this.selectedDate = { year: null, month: null, day: null };
  }
}
